import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes — cached data is reused within this window
      gcTime: 10 * 60 * 1000,   // 10 minutes — keep unused cache entries longer
      retry: 1,
      refetchOnWindowFocus: false, // don't refetch everything when switching tabs
    },
  },
});
